import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import './App.css';
import Footer from './common/Footer/Footer';
import theme, { mainFont, secondaryFont } from './theme';
import { useViewport, ViewportProvider } from './ViewportProvider';
import { Desktop } from './screens/Desktop';
import { Mobile } from './screens/Mobile';
// import {SocketContext, socket} from "./components/clientSocket";

//const uri = process.env.MONGODB_URI; //added this line to try and deploy using atlas cluster

export const useOtherStyles = makeStyles({
	banner: {
		textAlign: 'center',
		color: theme.palette.grey[100],
		padding: '10px 0px 30px',
		fontFamily: secondaryFont,
	},
	info: {
		textAlign: 'center',
		color: theme.palette.grey[100],
		fontFamily: secondaryFont,
	},
	hrDivider: {
		margin: '15px 0px 30px 0px',
		backgroundColor: theme.palette.common.black,
	},
  createItemButton: {
		// position: 'fixed',
		// right: '10vw',
		// bottom: 100,
		float: 'right',
		padding: '10px',
		fontSize: '10px',
		width: '250px',
		margin: '10px 0px 0px',
	},
});

export const useCardStyles = makeStyles({
	card: {
		margin: '5px 0',
		backgroundColor: theme.palette.primary.main,
	},
  cardHeader: {
    textAlign: 'left',
    marginLeft: '10px'
  },
  headerTitle: {
		fontWeight: 800,
		color: theme.palette.common.black,
	},
  sectionTitle: {
    margin: '30px 0px 10px'
  },
  sectionContent: {
    backgroundColor: theme.palette.primary.dark,
    padding: '10px',
    borderRadius: '5px',
	marginBottom: '10px'
  },
  altCard: {
    margin: '5px 0',
		backgroundColor: theme.palette.primary.light
  },
	clickable: {
		cursor: 'pointer',
	},
});

export const useFormStyles = makeStyles({
	formWrapper: {
		padding: '20px',
		margin: '30px auto 10px',
		borderRadius: '15px',
		width: '95%',
		maxWidth: '500px',
		// backgroundColor: theme.palette.grey[600]
	},
	formTitle: {
		textAlign: 'center',
		color: theme.palette.common.black,
		// fontFamily: mainFont
	},
	formSubtitle: {
		textAlign: 'center',
		padding: '10px',
		color: theme.palette.common.black,
	},
	formSwitchMessage: {
		cursor: 'default',
		color: theme.palette.common.black,
	},
	formSwitchLink: {
		cursor: 'pointer',
		color: theme.palette.common.black,
		textShadow: `1px 1px 3px ${theme.palette.primary.main}`,
	},
	formHint: {
		width: '100%',
		paddingLeft: theme.spacing(2),
		margin: '10px 0px 10px',
		color: theme.palette.common.black,
		paddingBottom: '20'
	}
});

const App: React.FC = () => {
	const { width } = useViewport();
	const breakpoint = 1000;

	return (
		<>
			<ViewportProvider>
				<ThemeProvider theme={theme}>
					<CssBaseline />
					{width < breakpoint ? (
            <Mobile />
					) : (
            <Desktop />
					)}
					{/* <Footer /> */}
				</ThemeProvider>
			</ViewportProvider>
		</>
	);
};

export default App;
